/* Compatibility for installed customizer blocks predating cart contract v1.
   New blocks declare data-cart-contract="1" and keep ownership themselves. */
(function () {
  'use strict';
  var pending = new WeakSet();

  function loading() {
    var host = document.querySelector('[data-fathead-host]');
    var root = host && host.shadowRoot;
    if (!root) return function () {};
    var style = document.createElement('style');
    style.textContent = '[data-fh-cart-loading]{display:inline-flex!important;align-items:center;justify-content:center;gap:10px;opacity:1!important;cursor:wait!important}' +
      '[data-fh-cart-loading]::before{content:"";width:16px;height:16px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:fhCartSpin .7s linear infinite}' +
      '@keyframes fhCartSpin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){[data-fh-cart-loading]::before{animation:none}}';
    root.appendChild(style);
    function decorate() {
      root.querySelectorAll('button').forEach(function (button) {
        if (/Adding to cart|Still working/i.test(button.textContent) && !button.hasAttribute('data-cart-submit-busy') && !button.hasAttribute('data-fh-cart-loading')) {
          button.setAttribute('data-fh-cart-loading', '');
          button.setAttribute('aria-busy', 'true');
        }
      });
    }
    var observer = new MutationObserver(decorate);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    decorate();
    return function () {
      observer.disconnect(); style.remove();
      root.querySelectorAll('[data-fh-cart-loading]').forEach(function (button) {
        button.removeAttribute('data-fh-cart-loading'); button.removeAttribute('aria-busy');
      });
    };
  }

  document.addEventListener('fathead:customized', function (event) {
    var element = event.target;
    var artifact = event.detail && event.detail.artifact;
    var cart = window.FatheadCart;
    if (!element || element.tagName !== 'FATHEAD-CUSTOMIZER' || !artifact || !cart || cart.version !== 1 ||
        element.getAttribute('data-cart-contract') === '1') return;
    // Claim the old block's event BEFORE its target listener can issue a POST.
    event.stopImmediatePropagation();
    if (pending.has(element)) return;
    pending.add(element);
    var stopLoading = loading();
    var origin = (element.getAttribute('app-origin') || 'https://fathead-customs.com').replace(/\/+$/, '');
    if (origin === 'https://fh-design-portal.vercel.app') origin = 'https://fathead-customs.com';
    Promise.resolve().then(function () {
      return fetch(origin + '/api/customizer/cart-properties', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ artifact: artifact, context: {
          productType: artifact.productType || 'big_head',
          sizeLabel: artifact.sizeLabel || artifact.imageWidth + 'x' + artifact.imageHeight,
          customProductTypeDisplay: artifact.customProductTypeDisplay || 'Custom',
          flipOrientation: artifact.flipOrientation || 'portrait'
        } })
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('We could not prepare your design. Please try again.');
      return response.json();
    }).then(function (payload) {
      if (!payload || !Array.isArray(payload.items) || !payload.items.length) throw new Error('We could not prepare your design. Please try again.');
      return cart.add({ items: payload.items }, { source: 'customizer_single', open: false });
    }).then(function (result) {
      if (!result || result.status !== 'confirmed' || result.schemaVersion !== 1) {
        var error = new Error('We could not confirm the update. Check your cart before trying again.');
        error.outcome = 'unknown'; throw error;
      }
    }).then(function () {
      stopLoading(); pending.delete(element);
      // Nothing below this boundary can turn the committed add into a retry.
      try { element.close(); } catch (_) {}
      cart.open();
    }, function (error) {
      stopLoading(); pending.delete(element);
      var message = error.outcome === 'unknown' ? 'We could not confirm the update. Check your cart before trying again.' :
        error.description || error.message || 'We could not add your design. Please try again.';
      if (typeof element.reportCartError === 'function') element.reportCartError(message, 'native-cart-handoff');
      else cart.notice(message);
    }).catch(function () {
      // Malformed adapter response or a post-commit UI failure needs recovery,
      // never a second cart/add request.
      stopLoading(); pending.delete(element);
      cart.notice('Check your cart before trying again.');
    });
  }, true);
})();
